import React from 'react';
import { twMerge } from 'tailwind-merge';

import { contentTypes } from '../../common/Constants';

type ContentType = (typeof contentTypes)[keyof typeof contentTypes];

type AssetIdProps = {
  assetId: string;
  assetType?: string;
  label?: string;
  className?: string;
};

export const getLabel = (contentType: ContentType): string => {
  const labelMap: Record<Partial<ContentType>, string> = {
    [contentTypes.FOOTAGE]: 'Stock video ID:',
    [contentTypes.ILLUSTRATION]: 'Illustration ID:',
    [contentTypes.VECTOR]: 'Vector ID:',
    [contentTypes.PHOTO]: 'Stock photo ID:',
    [contentTypes.SNAPSHOT]: 'Snapshot ID:',
    [contentTypes.MUSIC]: 'Stock music ID:',
  };

  return labelMap[contentType] || 'Asset ID:';
};
const AssetId = ({ assetId, label, className = '' }: AssetIdProps) => {
  // Use the custom label if provided, otherwise use the mapped label

  return (
    <div className={twMerge('mt-4', className)}>
      {label} {assetId}
    </div>
  );
};

export default AssetId;
